import { Link } from "react-router-dom";
import { trackEvent } from 'utils/Analytics';

const AnalyticLink = (props) => {
  const { children, onClick, tracking, ...rest } = props;

  const linkOnClick = (e) => {
    if (onClick) {
      onClick(e);
    }
    if (tracking) {
      trackEvent(tracking.category, tracking.action, tracking.label)
    }
  }

  return (
    <Link
      {...rest}
      onClick={linkOnClick}
    >
      {children}
    </Link>
  )
}

export default AnalyticLink;